export default __webpack_public_path__ + "static/media/setting.71dae774.svg";